import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { YardConfiguration } from 'src/tmc-yard/client/model/yard-configuration';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { StructureSelectionContext } from '../../../structure-selection.model';

@Component({
    selector: 'app-structure-selection',
    templateUrl: './structure-selection.component.html',
    styleUrls: ['./structure-selection.component.scss']
})
export class StructureSelectionComponent implements OnDestroy {

    stationGroups: Array<StationGroup>;

    selectedStationGroup: StationGroup = null;

    yardConfiguration: YardConfiguration;

    selectionContext: StructureSelectionContext;

    selectionChangeSubscription: Subscription;

    @Input('context') set setSelectionContext(value: StructureSelectionContext) {
        this.selectionContext = value;
        this.selectionChangeSubscription = this.selectionContext.selectionChange$.subscribe(selection => {
            if (selection.stationGroupId != null) {
                for (const stationGroup of this.stationGroups) {
                    if (stationGroup.id === selection.stationGroupId) {
                        this.selectedStationGroup = stationGroup;
                    }
                }
            } else {
                this.selectedStationGroup = null;
            }
        });
        this.initialzeSetStationGroupSelection();
    }

    constructor(
        public translationService: TranslationService,
        private tmcContextService: TmcContextService
    ) {
        this.tmcContextService.updated.subscribe(
            yardConfiguration => {
                this.yardConfiguration = yardConfiguration;
                this.initialzeSetStationGroupSelection();
            }
        );
    }

    private initialzeSetStationGroupSelection() {
        if (this.yardConfiguration != null && this.selectionContext != null) {
            this.stationGroups = this.yardConfiguration.stationGroups;
            if (this.stationGroups.length > 0) {
                this.selectionContext.setStationGroupSelection(this.stationGroups[0].id);
            }
        }
    }

    ngOnDestroy(): void {
        if (this.selectionChangeSubscription != null) {
            this.selectionChangeSubscription.unsubscribe();
            this.selectionChangeSubscription = null;
        }
    }

    onSelectionChanged(entry: MasterDetailListEntry) {
        const stationGroup = entry as StationGroup;
        this.selectionContext.setStationGroupSelection(stationGroup.id);
    }

}
